import { AttributionScope } from "@redotech/redo-attribution-common/attribution-scope";
import {
  AttributionModel,
  attributionSettingsSchema,
} from "@redotech/redo-attribution-common/attribution-settings";
import { attributionRowsSchema } from "@redotech/redo-marketing-common/attribution";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getAttribution = {
  name: "getAttribution" as const,
  input: z
    .object({
      groupBy: z
        .array(z.enum(AttributionScope))
        .describe("Scopes to group on; empty rolls up to one team total"),
      attributionSettings: attributionSettingsSchema,
      attributionModel: z
        .enum(AttributionModel)
        .optional()
        .describe(
          "Which attribution model to compute; defaults to the settings' defaultModel",
        ),
      from: zExt.instant().describe("Start instant, inclusive"),
      to: zExt.instant().describe("End instant, exclusive"),
    })
    .refine((input) => Temporal.Instant.compare(input.from, input.to) < 0, {
      message: "from must be before to",
    }),
  output: attributionRowsSchema,
};
